/**
 * A draft's failure, in words.
 *
 * The server answers with a code - `no_recipient`, `attachment_gone`,
 * `interrupted` - on a scheduled send that could not go, and on a schedule or a
 * "Send now" it refused. The codes are worded in the catalogue under
 * `drafts.error`; one the catalogue does not know is shown under a general
 * sentence rather than dropped, because the next person to read it may be the
 * one who can explain it.
 */
import { ApiError } from "../../../../lib/api";

type Translate = (key: string, vars?: Record<string, string>) => string;

export function draftErrorText(t: Translate, code: string): string {
  const key = `drafts.error.${code}`;
  const text = t(key);
  return text === key ? `${t("drafts.error.unknown")} (${code})` : text;
}

/** The same, for a request that threw. */
export function draftRequestError(t: Translate, err: unknown): string {
  const body = err instanceof ApiError ? (err.body as { error?: unknown } | null) : null;
  return typeof body?.error === "string" ? draftErrorText(t, body.error) : t("drafts.error.unknown");
}
